"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCadenceInstalledLibrary = isCadenceInstalledLibrary;
exports.isFromCadenceLibrary = isFromCadenceLibrary;
const CADENCE_INSTALL_DIRECTORY_PATTERN = /^(?:cadence|spb_.+|orcad.*)$/i;
const ROOTED_PATH_PATTERN = /^(?:[A-Za-z]:[\\/]|[\\/])/;
function isCadenceInstalledLibrary(sourceLibName) {
    if (!ROOTED_PATH_PATTERN.test(sourceLibName)) {
        return false;
    }
    const segments = sourceLibName
        .split(/[\\/]+/)
        .filter((segment) => segment.length > 0)
        .map((segment) => segment.toLowerCase());
    for (let index = 1; index + 2 < segments.length; index++) {
        if (segments[index] !== 'tools' || segments[index + 1] !== 'capture' || segments[index + 2] !== 'library') {
            continue;
        }
        return CADENCE_INSTALL_DIRECTORY_PATTERN.test(segments[index - 1]);
    }
    return false;
}
function isFromCadenceLibrary(sourceLibName, libraryName) {
    if (!isCadenceInstalledLibrary(sourceLibName)) {
        return false;
    }
    const fileName = sourceLibName.split(/[\\/]/).pop() ?? sourceLibName;
    return fileName.replace(/\.olb$/i, '').toUpperCase() === libraryName;
}
//# sourceMappingURL=orcadLibraryProvenance.js.map